import React from 'react';

interface IconProps { className?: string; }

export function CheckTick({ className }: IconProps): React.ReactElement {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L20 6" /></svg>
  );
}
